import styled, { css } from "styled-components";
import { CheckboxProps, CheckboxSize } from "./Checkbox.types";
import COLORS from "../../constants/colors";
import { getCommonFontStyleMixin } from "../../mixins/font";
const getSizeDimensions: Record<CheckboxSize, number> = {
    sm: 16,
    md: 20,
};

export const CheckboxInput = styled.input<Pick<CheckboxProps, "size" | "fillColor">>`
    appearance: none;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${({ size = "sm" }) => {
        return css`
            min-width: ${getSizeDimensions[size]}px;
            min-height: ${getSizeDimensions[size]}px;
            width: ${getSizeDimensions[size]}px;
            height: ${getSizeDimensions[size]}px;
        `;
    }}

    border-radius: 3px;
    border: 2px solid ${COLORS.GREY_300};
    background-color: ${COLORS.WHITE};
    outline: none;
    box-shadow: none;

    &:disabled {
        background-color: ${COLORS.GREY_100};

        &,
        & + label {
            cursor: not-allowed;
        }
    }

    &:checked {
        background-color: ${({ fillColor }) => fillColor};
        border: none;
        &::before {
            content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDExIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjI1IDRMMy41IDYuNTcxNDNMOS41IDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
        }
    }

    &,
    & + label {
        cursor: pointer;
    }
`;

export const CheckboxInputLabel = styled.label<
    Partial<NonNullable<CheckboxProps["labelProps"]>>
>`
    line-height: 150%;
    margin: 0;
    ${({ size, mSize, weight }) =>
        getCommonFontStyleMixin({ size, mSize, weight })}
`;

export const CheckboxWrapper = styled.span<any>`
    display: inline-flex;
    align-items: ${({ alignItems }) => alignItems};
    gap: 10px;
`;
